import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { Queue } from '@/components/settings-route/switchboard/queue'

export const Route = createFileRoute('/_auth/switchboard/queue')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Layout.Body className="flex w-full flex-col gap-3 overflow-hidden">
      <Queue />
    </Layout.Body>
  )
}
